import React, { useState } from "react";
import { Box, Input, Textarea, Image, Button, Flex, useToast } from "@chakra-ui/react";
import { formatTextWithLineBreaks } from "../../../../../utils/formatText";
import { deleteTeacher, updateTeacherProfile } from "../../../../../services/adminService";

const EditTeacher = ({ teacher, clerkId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(teacher.name);
  const [description, setDescription] = useState(teacher.text);
  const [newPhoto, setNewPhoto] = useState(null);
  const toast = useToast();

  const handleSave = async () => {
    const updatedTeacher = {
      ...teacher,  
      name,  
      text: description,  
    };    
    try {
      const response = await updateTeacherProfile(updatedTeacher, newPhoto, clerkId);
      if (response.status === 200) {
        toast({
          title: 'Teacher updated.',
          description: 'Teacher information has been updated successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        }); 
      } else{
        toast({
          title: 'Error',
          description: 'Error while trying to update teacher info.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }
      setIsEditing(false);
      console.log("Teacher updated successfully!");
    } catch (error) {
      console.error("Error saving teacher:", error);
    }
  };

  const handleDelete = async() =>{
    try{
      const response = await deleteTeacher(teacher.id, clerkId)
      if (response.ok){
        toast({
          title: 'Teacher deleted',
          description: 'Teacher data deleted successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
      } else{
        toast({
          title: 'error deleting teacher',
          description: 'error has occured while trying to delete teacher data',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }
      setIsEditing(false);
    } catch(error){
      console.error('error', error);
      setIsEditing(false);
      toast({
        title: 'error deleting teacher',
        description: `error:  ${error}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  const handleCancel = () => {
    // Reset fields to the original teacher's data
    setName(teacher.name);
    setDescription(teacher.text);
    setNewPhoto(null); 
    setIsEditing(false); 
  };

  return (
    <Flex flexDirection="column" p={4} alignItems="center" border="1px solid #ccc" mb={4}>
      {/* Display the teacher's photo */}
      <Image
        src={newPhoto ? URL.createObjectURL(newPhoto) : teacher.path}
        alt={teacher.name}
        boxSize="150px"
        borderRadius="full"
        mb={4}
      />

      {isEditing ? (
        <>
          <Input
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            mb={4}
            dir="rtl"
          />
          <Textarea
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            mb={4}
            dir="rtl"
          />
          <Input
            type="file"
            accept="image/*"
            onChange={(e) => setNewPhoto(e.target.files[0])}
            mb={4}
            dir="rtl"
          />
        </>
      ) : (
        <>
          {/* Display the teacher's name and description */}
          <Box textAlign="center">
            <Box fontSize="xl" fontWeight="bold" mb={2}>
              {teacher.name}
            </Box>
            <Box dir='rtl'>{formatTextWithLineBreaks(teacher.text)}</Box>
          </Box>
        </>
      )}

      <Flex mt={4}>
        {isEditing ? (
          <>
            <Button
              colorScheme="green"
              onClick={handleSave}
              mr={2}
              disabled={name === teacher.name && description === teacher.text && !newPhoto}
            >
              Save
            </Button>
            <Button
            colorScheme="red"
            onClick={handleDelete} 
            mr={2}>
              Delete
            </Button>
            <Button colorScheme="gray" onClick={handleCancel}>
              Cancel
            </Button>
          </>
        ) : (
          <Button colorScheme="blue" onClick={() => setIsEditing(true)}>
            Edit
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default EditTeacher;
